// extracted by mini-css-extract-plugin
export default {"container":"StatisticsText_container__fjTc7","shortStats":"StatisticsText_shortStats__2jmwM","container2":"StatisticsText_container2__OHGEY"};